
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.24 7.519v5.121c0 1.06.86 1.92 1.92 1.92H6.4v-3.2a1.6 1.6 0 113.2 0v3.2h2.24c1.06 0 1.92-.86 1.92-1.92V7.519A3.026 3.026 0 0112 8.08a3.03 3.03 0 01-2-.75 3.029 3.029 0 01-2 .75 3.03 3.03 0 01-2-.75 3.03 3.03 0 01-2 .75 3.026 3.026 0 01-1.76-.561z","fill":"#4D5078"}}),_c('path',{attrs:{"d":"M2.953 7.2c.316.154.672.24 1.047.24.376 0 .731-.086 1.048-.24H2.953zM6.953 7.2c.316.154.672.24 1.047.24.376 0 .731-.086 1.048-.24H6.953zM10.953 7.2h2.095A2.39 2.39 0 0112 7.44a2.39 2.39 0 01-1.047-.24z","fill":"#4D5078"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.031 1.44a1.28 1.28 0 00-1.17.76l-.47 1.058A2.4 2.4 0 106 6.367 2.398 2.398 0 008 7.44c.835 0 1.57-.426 2-1.073a2.4 2.4 0 103.608-3.109l-.47-1.058a1.28 1.28 0 00-1.17-.76H4.032z","fill":"#4D5078"}})])
          )
        }
      }
    